import { render, staticRenderFns } from "./CreateSimpleVenue.vue?vue&type=template&id=75087435"
import script from "./CreateSimpleVenue.vue?vue&type=script&lang=ts"
export * from "./CreateSimpleVenue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports